"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CheckboxStyled = require("./CheckboxStyled");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Checkbox = function Checkbox(_ref) {
  var children = _ref.children,
    onClickFn = _ref.onClickFn,
    error = _ref.error,
    checked = _ref.checked,
    required = _ref.required,
    isMyAccount = _ref.isMyAccount,
    className = _ref.className,
    disabled = _ref.disabled,
    isRadioButton = _ref.isRadioButton;
  var _useState = (0, _react.useState)(checked),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  (0, _react.useEffect)(function () {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/_react.default.createElement(_CheckboxStyled.CheckboxStyled, {
    onClick: function onClick(e) {
      e.stopPropagation();
      onClickFn(e, disabled, setIsChecked);
    },
    role: "checkbox",
    tabIndex: "-1",
    "aria-checked": isChecked,
    checked: isChecked,
    "aria-label": children,
    className: className,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_CheckboxStyled.CheckFrameStyled, {
    error: error && required && !isChecked,
    tabIndex: "0",
    onKeyDown: function onKeyDown(e) {
      return e.keyCode === 32 ? onClickFn() : null;
    },
    isMyAccount: isMyAccount,
    isRadioButton: isRadioButton,
    checked: isChecked
  }, isChecked && /*#__PURE__*/_react.default.createElement(_CheckboxStyled.CheckMarkStyled, {
    "data-testid": "checkmark",
    isMyAccount: isMyAccount,
    isRadioButton: isRadioButton
  })), /*#__PURE__*/_react.default.createElement(_CheckboxStyled.ConsentDefinitionStyled, {
    dangerouslySetInnerHTML: {
      __html: "".concat(children).concat(required && isMyAccount ? '*' : '')
    },
    checked: isChecked
  }));
};
Checkbox.propTypes = {
  checked: _propTypes.default.bool,
  required: _propTypes.default.bool,
  onClickFn: _propTypes.default.func,
  error: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  isMyAccount: _propTypes.default.bool,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  isRadioButton: _propTypes.default.bool
};
Checkbox.defaultProps = {
  error: '',
  checked: false,
  required: false,
  onClickFn: function onClickFn() {},
  children: '',
  isMyAccount: false,
  className: '',
  disabled: false,
  isRadioButton: false
};
var _default = Checkbox;
exports.default = _default;